__turbopack_context__.v({
  "content": "nav-bar-module-scss-module__oqADpG__content",
  "root": "nav-bar-module-scss-module__oqADpG__root",
  "withBackground": "nav-bar-module-scss-module__oqADpG__withBackground",
});
